export { default } from './SectionRequirements';